module.exports = __webpack_public_path__ + "img/careem.e40baff7.png";